import MiniMenu from './MiniMenu'

export default MiniMenu
